<template>
  <div>
<!--    <div id="global-loader" >-->
<!--			<div class="whirly-loader"> </div>-->
<!--		</div>-->

		<!-- Main Wrapper -->
		<div class="main-wrapper">
			<div class="page-wrapper pos-pg-wrapper ms-0">
				<div class="content pos-design p-0">
<!--					<div class="btn-row d-sm-flex align-items-center">-->
<!--						<a href="javascript:void(0);" class="btn btn-secondary mb-xs-3" data-bs-toggle="modal" data-bs-target="#orders"><span class="me-1 d-flex align-items-center"><i data-feather="shopping-cart" class="feather-16"></i></span>View Orders</a>-->
<!--						<a href="javascript:void(0);" class="btn btn-info"><span class="me-1 d-flex align-items-center"><i data-feather="rotate-cw" class="feather-16"></i></span>Reset</a>-->
<!--						<a href="javascript:void(0);" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#recents"><span class="me-1 d-flex align-items-center"><i data-feather="refresh-ccw" class="feather-16"></i></span>Transaction</a>-->
<!--					</div>-->

					<div class="row align-items-start pos-wrapper">
						<div class="col-md-12 col-lg-6">
							<aside class="product-order-list">
                <div class="customer-info block-section position-relative">

                  <!-- Customer Select and Create Button -->
                  <div class="input-block d-flex align-items-center mb-3">
                    <div class="col-6 d-flex me-3">
                      <div class="flex-grow-1">
                        <input
                          type="text"
                          v-model="c_query"
                          @input="searchCustomer"
                          placeholder="Search Customer by Name, phone no"
                          class="form-control"
                          @keydown="handleKey"
                        />

                        <!-- Dropdown Search Results -->
                        <div
                          v-if="c_query"
                          class="search-results shadow rounded bg-white position-absolute mt-2"
                          style="width:450px; max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
                          :class="{ 'd-block': c_results.length > 0, 'd-none': c_results.length === 0 }"
                        >

                          <!-- Results List -->
                          <ul class="list-group list-group-flush">
                            <li
                              v-for="(customer, index) in c_results"
                              :key="customer.id"
                              class="list-group-item d-flex justify-content-between align-items-center"
                              :class="{ 'bg-primary text-white': index === selectedCustomerIndex }"
                              style="padding: 14px; font-size: 1rem; cursor: pointer;"
                              @click="selectCustomer(customer)"
                            >
                              <div class="flex-grow-1">
                                <strong>{{ customer.customer_name }}</strong> - {{ customer.customer_phone }}
                              </div>
                            </li>
                          </ul>

                          <!-- No Results -->
                          <div v-if="!c_results.length" class="text-center text-muted py-4" style="font-size: 1rem;">
                            No results found
                          </div>
                        </div>
                      </div>
                      <a href="#" class="btn btn-primary btn-icon ms-2" data-bs-toggle="modal" data-bs-target="#create">
                        <i class="ti ti-users-plus text-white"></i>
                      </a>
                    </div>
                    <div class="col-6 d-flex flex-column gap-1">
                      <span><strong>Latest Invoice No: #{{ voucher_id }}</strong></span>
                      <span><strong>Next Invoice No: #{{ next_invoice_id }}</strong></span>
                    </div>
                  </div>

                  <!-- Search Input -->
                  <div class="position-relative">
                    <input
                      type="text"
                      v-model="query"
                      @input="debouncedSearch"
                      placeholder="Search Items by Name, Code, SKU or Barcode"
                      class="form-control"
                      autocomplete="off"
                      @keydown="handleKeys"
                    />
                    <div class="search-addon position-absolute top-50 end-0 translate-middle-y me-3" v-if="query" style="cursor: pointer;">
                      <span @click="clearSearch">
                        <i class="fa fa-times"></i>
                      </span>
                    </div>
                  </div>

                  <!-- Dropdown Search Results -->
                  <div
                    v-if="query"
                    class="search-results shadow rounded bg-white position-absolute w-100 mt-2"
                    style="max-height: 400px; overflow-y: auto; z-index: 1050;"
                    :class="{ 'd-block': results.length > 0, 'd-none': results.length === 0 }"
                  >

                    <!-- Results List -->
                    <ul class="list-group list-group-flush">
                      <li
                        v-for="(item, index) in results"
                        :key="item.id"
                        class="list-group-item d-flex justify-content-between align-items-center"
                        :class="{ 'bg-primary text-white': index === selectedItem }"
                        style="gap: 10px;"
                      >
                        <!-- Clickable Product Info -->
                        <div
                          class="flex-grow-1 d-flex flex-column"
                          @click="addItem(item)"
                          style="cursor: pointer;"
                        >
                          <div class="d-flex align-items-center gap-2">
                            <!-- Image Wrapper -->
                            <div
                              style="width:50px; height:50px; border-radius:4px; overflow:hidden; flex-shrink:0;"
                            >
                              <img
                                :src="$getImageUrl(item.images)"
                                alt="Items"
                                style="width:100%; height:100%; object-fit:cover;"
                              />
                            </div>

                            <!-- Item Info -->
                            <div class="d-flex flex-column">
                              <strong class="text-dark">{{ item.item_name }} - {{ item.item_code }}</strong>
                              <span
                                style="font-size: 0.75rem; width: fit-content; color: black"
                              >
                                Stock: {{ item.stock_quantity }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <!-- Quantity Input -->
                        <input
                          type="number"
                          min="1"
                          :max="item.stock_quantity"
                          v-model.number="item.quantity"
                          placeholder="1"
                          class="form-control form-control-sm"
                          style="width: 80px;"
                          @click.stop
                        />

                        <!-- Add Button -->
                        <button
                          class="btn btn-sm btn-success"
                          @click.stop="addItem(item)"
                        >
                          Add
                        </button>
                      </li>
                    </ul>

                    <div v-if="!results.length" class="text-center text-muted py-3">
                      No results found
                    </div>
                  </div>
                </div>

								<div class="product-added block-section border rounded">
                  <div class="order-total px-1 py-3">
                    <div class="head-text d-flex align-items-center justify-content-between border-bottom">
                      <h6 class="d-flex align-items-center mb-2">Item Added<span class="badge bg-primary ms-2">{{addedItems.length}}</span></h6>
                      <a
                        v-if="addedItems.length"
                        class="d-flex align-items-center text-danger"
                        @click="clearAll"
                      >
                        <span class="me-1">
                          <i data-feather="x" class="feather-16"></i>
                        </span>Clear all
                      </a>
                    </div>

                    <div class="product-wrap">
                      <div
                        class="product-list d-flex align-items-center justify-content-between px-2 bg-white"
                        v-for="(item, index) in addedItems"
                        :key="item.id"
                        style="height: 70px; border-bottom: 1px solid #e9ecef;"
                      >
                        <!-- Product Info -->
                        <div class="d-flex align-items-center product-info">
                          <div
                            style="width:50px; height:50px; border-radius:4px; overflow:hidden; flex-shrink:0;"
                          >
                            <img
                              :src="$getImageUrl(item.images)"
                              alt="Items"
                              style="width:100%; height:100%; object-fit:cover;"
                            />
                          </div>
                          <div class="ms-2">
                            <span style="font-size: 16px; font-weight: bold;">{{ item.item_name }} - ({{ item.stock_quantity }})</span>
                          </div>

                          <div class="ms-2" v-if="isItemWiseVat() && Number(item.discount) > 0">
                            <span class="text-success" style="font-size: 12px;">
                              - (Discount {{ Number(item.discount).toFixed(0) }}%)
                            </span>
                          </div>
                        </div>

                        <!-- Quantity -->
                        <div class="qty-item d-flex justify-content-center align-items-center">
                          <a href="#"
                             class="dec d-flex justify-content-center align-items-center"
                             @click="decreaseQty(item)"
                             :class="{disable: item.stock_quantity <= 1}"
                             title="minus"
                          >
                            <i data-feather="minus-circle" class="feather-14"></i>
                          </a>

                          <input type="text"
                                 class="form-control text-center qty-input"
                                 name="qty"
                                 v-model="item.quantity"
                                 readonly
                          >

                          <a href="#"
                             class="inc d-flex justify-content-center align-items-center"
                             @click="increaseQty(item)"
                             :class="{ disabled: item.quantity >= item.stock_quantity }"
                             title="plus"
                          >
                            <i data-feather="plus-circle" class="feather-14"></i>
                          </a>
                        </div>

                        <!-- Delete -->
                        <div class="action d-flex align-items-center">
                          <a class="btn-icon delete-icon confirm-text" @click="removeItem(item)">
                            <i data-feather="trash-2" class="feather-14"></i>
                          </a>
                        </div>

                        <!-- Total Price -->
                        <div class="total-price ms-2">
                          <strong>৳{{ (Number(item.quantity || 0) * Number(item.selling_price || 0)).toFixed(2) }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
								</div>
							</aside>
						</div>

            <div class="col-md-12 col-lg-3 ps-0">
              <aside class="product-order-list">
                <div class="block-section">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td>Sub Total</td>
                        <td class="text-end"><strong style="font-size: 1.25rem">৳{{ calculateSubtotal() }}</strong></td>
                      </tr>
                      <tr>
                        <td>Vat</td>
                        <td class="text-end"><strong style="font-size: 1.25rem">৳{{ vatAmount }}</strong></td>
                      </tr>
                      <tr >
                        <td>
                          <div class="d-flex align-items-center justify-content-between">
                            <span>Discount (%):</span>
                            <input type="number"
                             v-model.number="discountPercent"
                             class="form-control form-control-sm small-input"
                             min="0" max="100"
                             :disabled="
                              vat_policy === 'Price including Item-wise VAT' ||
                              vat_policy === 'Price excluding Item-wise VAT'"
                            />
                          </div>
                        </td>
                        <td class="text-end">
                          <strong style="font-size: 1.25rem">৳{{ calculateDiscount() }}</strong>
                        </td>
                      </tr>

<!--                      <tr>-->
<!--                        <td>-->
<!--                          <div class="d-flex align-items-center justify-content-between">-->
<!--                            <span>Discount amount:</span>-->
<!--                            <input type="text"-->
<!--                             v-model="discountFixed"-->
<!--                             @input="discountFixed = discountFixed.replace(/[^0-9]/g, '')"-->
<!--                             class="form-control form-control-sm small-input "-->
<!--                             placeholder="৳0"-->
<!--                            />-->
<!--                          </div>-->
<!--                        </td>-->
<!--                        <td class="text-end">-->
<!--                          <strong style="font-size: 1.25rem">৳{{ calculateFixedDiscount() }}</strong>-->
<!--                        </td>-->
<!--                      </tr>-->

                      <tr>
                        <td>Total Payable</td>
                        <td class="text-end" style="font-size: 1.25rem;"><strong>৳{{ calculateTotal() }}</strong></td>
                      </tr>

                      <tr>
                        <td class="fw-semibold">
                          Received Amount:
                        </td>
                        <td class="text-end">
                          <input
                            type="text"
                            v-model="receivedAmount"
                            @input="receivedAmount = receivedAmount.replace(/[^0-9]/g, '')"
                            class="form-control form-control-sm big-placeholder"
                            style="
                              width: 125px;
                              max-width: 125px;
                              display: inline-block;
                              font-size: 1.25rem;
                              text-align: right;
                              "
                            placeholder="৳0"
                          />
                        </td>
                      </tr>

                      <tr>
                        <!-- Due -->
                        <td class="text-start">
                          <span class="fw-semibold me-1">Due:</span>
                          <strong
                            v-if="isPayable"
                            class="text-danger"
                            style="font-size: 1.25rem;"
                          >
                            ৳{{ dueAmount}}
                          </strong>
                          <strong v-else class="text-muted" style="font-size: 1.25rem;">
                            ৳0.00
                          </strong>
                        </td>

                        <!-- Return -->
                        <td class="text-end">
                          <span class="fw-semibold me-1">Change:</span>
                          <strong
                            v-if="isReturn"
                            class="text-success"
                            style="font-size: 1.25rem;"
                          >
                            ৳{{ returnAmount.toFixed(2) }}
                          </strong>
                          <strong v-else class="text-muted" style="font-size: 1.25rem;">
                            ৳0.00
                          </strong>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">
                          <div class="d-flex align-items-center">
                            <label class="form-label me-2 mb-0">Payment Type <span class="text-danger">*</span></label>
                            <VueSelect2
                              v-model="payment_method"
                              :options="formattedpaymenttypes"
                              :settings="{ allowClear: true, tags: true }"
                              @change="onChange"
                              class="form-control"
                              style="max-width: 300px;"
                            />
                          </div>
                          <div v-if="errors.payment_method" class="text-danger mt-1">{{ errors.payment_method }}</div>
                        </td>
                      </tr>

                      <tr>
                        <td class="fw-semibold">
                          Reference No:
                        </td>
                        <td class="text-end">
                          <input
                            type="text"
                            v-model="reference_no"
                            class="form-control form-control-sm big-placeholder"
                            placeholder="Enter Reference No"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="payment-actions d-grid gap-2 mt-3">
                    <!-- Use button for accessibility (anchor is okay but button is semantically correct) -->
                    <button type="button" class="btn btn-secondary action-btn w-100 py-3" style="font-size: 1.25rem; font-weight: 600;" aria-label="Grand total">
                      Grand Total : ৳{{ calculateTotal() }}
                    </button>

                    <button @click="submitPayment" type="button" class="btn btn-success action-btn w-100 py-3" style="font-size: 1.25rem; font-weight: 600;" aria-label="Confirm payment">
                      Confirm Payment
                    </button>
                  </div>
                </div>
              </aside>
            </div>

						<div class="col-md-12 col-lg-3 ps-0">
              <div class="pos-categories tabs_wrapper">
                  <div class="pos-products">
                    <div class="d-flex align-items-center justify-content-between">
                      <h5 class="mb-3">Best Selling Products</h5>
                    </div>
                    <div class="tabs_container">
                      <div  class="tab_content active" data-tab="all">
                        <div class="row">
                          <div
                            v-for="product in bestSellingProducts"
                            :key="product.id"
                            class="col-sm-2 col-md-6 col-lg-6 col-xl-6"
                          >
                            <div class="product-info default-cover card" @click="addItem(product)">
                              <a href="javascript:void(0);" class="img-bg">
                                <img
                                  :src="$getImageUrl(product.images)"
                                  alt="Items"
                                  style="width:80%; height:80%; object-fit:cover;"
                                />
                                <span>
                                  <i data-feather="check" class="feather-16"></i>
                                </span>
                              </a>

                              <h6 class="cat-name">{{ product.category }}</h6>
                              <h6 class="product-name">{{ product.item_name }}</h6>

                              <div class="d-flex align-items-center justify-content-between price">
                                <span>{{ product.stock_quantity || 0 }} Pcs</span>
                                <p>৳{{ product.selling_price }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- /Main Wrapper -->

		<!-- Payment Completed -->
		<div class="modal fade modal-default" id="payment-completed" aria-labelledby="payment-completed">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-body text-center">
						<form action="pos.html">
							<div class="icon-head">
								<a href="javascript:void(0);">
									<i data-feather="check-circle" class="feather-40"></i>
								</a>
							</div>
							<h4>Payment Completed</h4>
							<p class="mb-0">Do you want to Print Receipt for the Completed Order</p>
							<div class="modal-footer d-sm-flex justify-content-between">
								<button type="button" class="btn btn-primary flex-fill" data-bs-toggle="modal" data-bs-target="#print-receipt">Print Receipt<i class="feather-arrow-right-circle icon-me-5"></i></button>
								<button type="submit" class="btn btn-secondary flex-fill">Next Order<i class="feather-arrow-right-circle icon-me-5"></i></button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Payment Completed -->

		<!-- Print Receipt -->
		<div class="modal fade modal-default" id="print-receipt" aria-labelledby="print-receipt">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="d-flex justify-content-end">
						<button type="button" class="close p-0" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="icon-head text-center">
							<a href="javascript:void(0);">
								<img src="/assets/img/logo.svg" width="100" height="30" alt="Receipt Logo">
							</a>
						</div>
						<div class="text-center info text-center">
							<h6>Dreamguys Technologies Pvt Ltd.,</h6>
							<p class="mb-0">Phone Number: +1 5656665656</p>
							<p class="mb-0">Email: <a href="mailto:example@gmail.com">example@gmail.com</a></p>
						</div>
						<div class="tax-invoice">
							<h6 class="text-center">Tax Invoice</h6>
							<div class="row">
								<div class="col-sm-12 col-md-6">
									<div class="invoice-user-name"><span>Name: </span><span>John Doe</span></div>
									<div class="invoice-user-name"><span>Invoice No: </span><span>CS132453</span></div>
								</div>
								<div class="col-sm-12 col-md-6">
									<div class="invoice-user-name"><span>Customer Id: </span><span>#LL93784</span></div>
									<div class="invoice-user-name"><span>Date: </span><span>01.07.2022</span></div>
								</div>
							</div>
						</div>
						<table class="table-borderless w-100 table-fit">
							<thead>
								<tr>
									<th>Item</th>
									<th>Price</th>
									<th>Qty</th>
									<th class="text-end">Total</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>1. Red Nike Laser</td>
									<td>৳50</td>
									<td>3</td>
									<td class="text-end">৳150</td>
								</tr>
								<tr>
									<td>2. Iphone 14</td>
									<td>৳50</td>
									<td>2</td>
									<td class="text-end">৳100</td>
								</tr>
								<tr>
									<td>3. Apple Series 8</td>
									<td>৳50</td>
									<td>3</td>
									<td class="text-end">৳150</td>
								</tr>
								<tr>
									<td colspan="4">
										<table class="table-borderless w-100 table-fit">
                      <tbody>
                        <tr>
                          <td>Sub Total :</td>
                          <td class="text-end">৳700.00</td>
                        </tr>
                        <tr>
                          <td>Discount :</td>
                          <td class="text-end">-৳50.00</td>
                        </tr>
                        <tr>
                          <td>Shipping :</td>
                          <td class="text-end">0.00</td>
                        </tr>
                        <tr>
                          <td>Tax (5%) :</td>
                          <td class="text-end">৳5.00</td>
                        </tr>
                        <tr>
                          <td>Total Bill :</td>
                          <td class="text-end">৳655.00</td>
                        </tr>
                        <tr>
                          <td>Due :</td>
                          <td class="text-end">৳0.00</td>
                        </tr>
                        <tr>
                          <td>Total Payable :</td>
                          <td class="text-end">৳655.00</td>
                        </tr>
                      </tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
						<div class="text-center invoice-bar">
							<p>**VAT against this challan is payable through central registration. Thank you for your business!</p>
							<a href="javascript:void(0);">
								<img src="/assets/img/barcode/barcode-03.jpg" alt="Barcode">
							</a>
							<p>Sale 31</p>
							<p>Thank You For Shopping With Us. Please Come Again</p>
							<a href="javascript:void(0);" class="btn btn-primary">Print Receipt</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Print Receipt -->

		<!-- Products -->
		<div class="modal fade modal-default pos-modal" id="products" aria-labelledby="products">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header p-4 d-flex align-items-center justify-content-between">
						<div class="d-flex align-items-center">
							<h5 class="me-4">Products</h5>
							<span class="badge bg-info d-inline-block mb-0">Order ID : #666614</span>
						</div>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<form action="pos.html">
							<div class="product-wrap">
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-16.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0005</span>
												<h6><a href="javascript:void(0);">Red Nike Laser</a></h6>
											</div>
											<p>৳2000</p>
										</div>
									</div>

								</div>
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-17.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0235</span>
												<h6><a href="javascript:void(0);">Iphone 14</a></h6>
											</div>
											<p>৳3000</p>
										</div>
									</div>
								</div>
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-16.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0005</span>
												<h6><a href="javascript:void(0);">Red Nike Laser</a></h6>
											</div>
											<p>৳2000</p>
										</div>
									</div>
								</div>
								<div class="product-list d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center flex-fill">
										<a href="javascript:void(0);" class="img-bg me-2">
											<img src="/assets/img/products/pos-product-17.png" alt="Products">
										</a>
										<div class="info d-flex align-items-center justify-content-between flex-fill">
											<div>
												<span>PT0005</span>
												<h6><a href="javascript:void(0);">Red Nike Laser</a></h6>
											</div>
											<p>৳2000</p>
										</div>
									</div>
								</div>
							</div>
							<div class="modal-footer d-sm-flex justify-content-end">
								<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
								<button type="submit" class="btn btn-primary">Submit</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Products -->

    <!-- Create Customer Modal -->
    <div class="modal fade" id="create" tabindex="-1" aria-labelledby="createCustomerLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="submitCustomer">
            <div class="modal-header">
              <h5 class="modal-title" id="createCustomerLabel">{{ $t("add_new_customer") }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <!-- Customer Name -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Customer Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="customer.customer_name"
                    class="form-control"
                    placeholder="Enter customer name"
                  />
                  <div v-if="errors.customer_name" class="text-danger mt-1">{{ errors.customer_name }}</div>
                </div>

                <!-- Phone -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Phone <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="customer.customer_phone"
                    class="form-control"
                    placeholder="Enter phone number"
                  />
                  <div v-if="errors.customer_phone" class="text-danger mt-1">{{ errors.customer_phone }}</div>
                </div>

                <!-- Customer Code -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Customer Code </label>
                  <input
                    type="number"
                    v-model.number="customer.customer_code"
                    class="form-control"
                    placeholder="Enter customer code"
                  />
                  <div v-if="errors.customer_code" class="text-danger mt-1">{{ errors.customer_code }}</div>
                </div>

                <!-- Due Limit -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Due Limit</label>
                  <input
                    type="number"
                    step="0.01"
                    v-model.number="customer.due_limit"
                    class="form-control"
                    placeholder="Enter due limit"
                  />
                  <div v-if="errors.due_limit" class="text-danger mt-1">{{ errors.due_limit }}</div>
                </div>

                <!-- Due Limit Days -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Due Limit Days</label>
                  <input
                    type="number"
                    v-model.number="customer.due_limit_days"
                    class="form-control"
                    placeholder="Enter due limit days"
                  />
                  <div v-if="errors.due_limit_days" class="text-danger mt-1">{{ errors.due_limit_days }}</div>
                </div>

                <!-- Customer Address -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Address</label>
                  <input
                    type="text"
                    v-model="customer.customer_address"
                    class="form-control"
                    placeholder="Enter customer address"
                  />
                  <div v-if="errors.customer_address" class="text-danger mt-1">{{ errors.customer_address }}</div>
                </div>

                <!-- Customer Bank -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Bank</label>
                  <input
                    type="text"
                    v-model="customer.customer_bank"
                    class="form-control"
                    placeholder="Enter customer bank"
                  />
                  <div v-if="errors.customer_bank" class="text-danger mt-1">{{ errors.customer_bank }}</div>
                </div>

                <!-- Contact Person -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Contact Person</label>
                  <input
                    type="text"
                    v-model="customer.customer_contact_person"
                    class="form-control"
                    placeholder="Enter contact person"
                  />
                  <div v-if="errors.customer_contact_person" class="text-danger mt-1">{{ errors.customer_contact_person }}</div>
                </div>

                <!-- Email -->
                <div class="col-lg-6 col-md-6 mb-3">
                  <label class="form-label">Email </label>
                  <input
                    type="email"
                    v-model="customer.customer_email"
                    class="form-control"
                    placeholder="Enter email"
                  />
                  <div v-if="errors.customer_email" class="text-danger mt-1">{{ errors.customer_email }}</div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div class="btn-addproduct mb-4">
                <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
                <button type="submit" class="btn btn-submit">{{ $t('submit') }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

		<!-- Hold -->
		<div class="modal fade modal-default pos-modal" id="hold-order" aria-labelledby="hold-order">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header p-4">
						<h5>Hold order</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<form action="pos.html">
							<h2 class="text-center p-4">4500.00</h2>
							<div class="input-block">
								<label>Order Reference</label>
								<input class="form-control" type="text" value="" placeholder="">
							</div>
							<p>The current order will be set on hold. You can retreive this order from the pending order button. Providing a reference to it might help you to identify the order more quickly.</p>
							<div class="modal-footer d-sm-flex justify-content-end">
								<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
								<button type="submit" class="btn btn-primary">Confirm</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Hold -->

		<!-- Edit Product -->
		<div class="modal fade modal-default pos-modal" id="edit-product" aria-labelledby="edit-product">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header p-4">
						<h5>Red Nike Laser</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<form action="pos.html">
							<div class="row">
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Product Name <span>*</span></label>
										<input type="text" placeholder="45">
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Tax Type <span>*</span></label>
										<select class="select">
											<option>Exclusive</option>
											<option>Inclusive</option>
										</select>
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Tax <span>*</span></label>
										<input type="text" placeholder="% 15">
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Discount Type <span>*</span></label>
										<select class="select">
											<option>Percentage</option>
											<option>Early payment discounts</option>
										</select>
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Discount <span>*</span></label>
										<input type="text" placeholder="15">
									</div>
								</div>
								<div class="col-lg-6 col-sm-12 col-12">
									<div class="input-blocks add-product">
										<label>Sale Unit <span>*</span></label>
										<select class="select">
											<option>Kilogram</option>
											<option>Grams</option>
										</select>
									</div>
								</div>
							</div>

							<div class="modal-footer d-sm-flex justify-content-end">
								 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
	        					<button type="submit" class="btn btn-primary">Submit</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /Edit Product -->

		<!-- Recent Transactions -->
		<div class="modal fade pos-modal" id="recents" tabindex="-1"    aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header p-4">
						 <h5 class="modal-title" >Recent Transactions</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<div class="tabs-sets">
							<ul class="nav nav-tabs" id="myTab" role="tablist">
								<li class="nav-item" role="presentation">
								  <button class="nav-link active" id="purchase-tab" data-bs-toggle="tab" data-bs-target="#purchase" type="button"   aria-controls="purchase" aria-selected="true" role="tab">Purchase</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="payment-tab" data-bs-toggle="tab" data-bs-target="#payment" type="button"   aria-controls="payment" aria-selected="false" role="tab">Payment</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="return-tab" data-bs-toggle="tab" data-bs-target="#return" type="button"   aria-controls="return" aria-selected="false" role="tab">Return</button>
								</li>
							  </ul>
							  <div class="tab-content" >
								<div class="tab-pane fade show active" id="purchase" role="tabpanel" aria-labelledby="purchase-tab">
									<div class="table-top">
										<div class="search-set">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
										<div class="wordset">
											<ul>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i data-feather="printer" class="feather-rotate-ccw"></i></a>
												</li>
											</ul>
										</div>
									</div>
									<div class="table-responsive">
										<table class="table datanew">
											<thead>
												<tr>
													<th>Date</th>
													<th>Reference</th>
													<th>Customer</th>
													<th>Amount	</th>
													<th class="no-sort">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0101</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0102</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0103</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0104</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0105</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0106</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0107</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div class="tab-pane fade" id="payment" role="tabpanel" >
									<div class="table-top">
										<div class="search-set">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
										<div class="wordset">
											<ul>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>
												</li>
												<li>
													<a class="d-flex align-items-center justify-content-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i data-feather="printer" class="feather-rotate-ccw"></i></a>
												</li>
											</ul>
										</div>
									</div>
									<div class="table-responsive">
										<table class="table datanew">
											<thead>
												<tr>
													<th>Date</th>
													<th>Reference</th>
													<th>Customer</th>
													<th>Amount	</th>
													<th class="no-sort">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0101</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0102</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0103</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0104</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0105</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0106</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0107</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div class="tab-pane fade" id="return" role="tabpanel" >
									<div class="table-top">
										<div class="search-set">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
										<div class="wordset">
											<ul>
												<li>
													<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf" class="d-flex align-items-center justify-content-center"><img src="/assets/img/icons/pdf.svg" alt="img"></a>
												</li>
												<li>
													<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel" class="d-flex align-items-center justify-content-center"><img src="/assets/img/icons/excel.svg" alt="img"></a>
												</li>
												<li>
													<a data-bs-toggle="tooltip" data-bs-placement="top" title="Print" class="d-flex align-items-center justify-content-center"><i data-feather="printer" class="feather-rotate-ccw"></i></a>
												</li>
											</ul>
										</div>
									</div>
									<div class="table-responsive">
										<table class="table datanew">
											<thead>
												<tr>
													<th>Date</th>
													<th>Reference</th>
													<th>Customer</th>
													<th>Amount	</th>
													<th class="no-sort">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0101</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0102</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0103</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0104</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0105</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0106</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
												<tr>
													<td>19 Jan 2023</td>
													<td>INV/SL0107</td>
													<td>Walk-in Customer</td>
													<td>৳1500.00</td>
													<td class="action-table-data">
														<div class="edit-delete-action">
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="eye" class="feather-eye"></i></a>
															<a class="me-2 p-2" href="javascript:void(0);"><i data-feather="edit" class="feather-edit"></i></a>
															<a class="p-2 confirm-text" href="javascript:void(0);"><i data-feather="trash-2" class="feather-trash-2"></i></a>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Recent Transactions -->

		<!-- Recent Transactions -->
		<div class="modal fade pos-modal" id="orders" tabindex="-1"  aria-hidden="true">
			<div class="modal-dialog modal-md modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header p-4">
						 <h5 class="modal-title" >Orders</h5>
						<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-body p-4">
						<div class="tabs-sets">
							<ul class="nav nav-tabs" id="myTabs" role="tablist">
								<li class="nav-item" role="presentation">
								  <button class="nav-link active" id="onhold-tab" data-bs-toggle="tab" data-bs-target="#onhold" type="button"   aria-controls="onhold" aria-selected="true" role="tab">Onhold</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="unpaid-tab" data-bs-toggle="tab" data-bs-target="#unpaid" type="button"   aria-controls="unpaid" aria-selected="false" role="tab">Unpaid</button>
								</li>
								<li class="nav-item" role="presentation">
								  <button class="nav-link" id="paid-tab" data-bs-toggle="tab" data-bs-target="#paid" type="button"   aria-controls="paid" aria-selected="false" role="tab">Paid</button>
								</li>
							  </ul>
							  <div class="tab-content" >
								<div class="tab-pane fade show active" id="onhold" role="tabpanel" aria-labelledby="onhold-tab">
									<div class="table-top">
										<div class="search-set w-100 search-order">
											<div class="search-input w-100">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
									</div>
									<div class="order-body">
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-secondary d-inline-block mb-4">Order ID : #666659</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Botsford</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳900</td>
                              </tr>
                              <tr>
															<td>Date</td>
															<td class="colon">:</td>
															<td class="text">29-08-2023 13:39:11</td>
														</tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-sm-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-secondary d-inline-block mb-4">Order ID : #666660</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
															<td>Customer</td>
															<td class="colon">:</td>
															<td class="text">Smith</td>
														</tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳15000</td>
                              </tr>
                              <tr>
															<td>Date</td>
															<td class="colon">:</td>
															<td class="text">30-08-2023 15:59:11</td>
														</tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4">
											<span class="badge bg-secondary d-inline-block mb-4">Order ID : #666661</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">John David</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳2000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">01-09-2023 13:15:00</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4 mb-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
									</div>

								</div>
								<div class="tab-pane fade" id="unpaid" role="tabpanel" >
									<div class="table-top">
										<div class="search-set w-100 search-order">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>

									</div>
									<div class="order-body">
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-info d-inline-block mb-4">Order ID : #666662</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Anastasia</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳2500</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">10-09-2023 17:15:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-info d-inline-block mb-4">Order ID : #666663</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Lucia</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳1500</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">11-09-2023 14:50:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-info d-inline-block mb-4">Order ID : #666664</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Diego</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳30000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">12-09-2023 17:22:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4 mb-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
									</div>
								</div>
								<div class="tab-pane fade" id="paid" role="tabpanel" >
									<div class="table-top">
										<div class="search-set w-100 search-order">
											<div class="search-input">
												<a class="btn btn-searchset d-flex align-items-center h-100"><img src="/assets/img/icons/search-white.svg" alt="img"></a>
											</div>
										</div>
									</div>
									<div class="order-body">
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-primary d-inline-block mb-4">Order ID : #666665</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Hugo</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳5000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">13-09-2023 19:39:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-primary d-inline-block mb-4">Order ID : #666666</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">Antonio</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳7000</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">15-09-2023 18:39:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
										<div class="default-cover p-4 mb-4">
											<span class="badge bg-primary d-inline-block mb-4">Order ID : #666667</span>
											<div class="row">
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr class="mb-3">
                                <td>Cashier</td>
                                <td class="colon">:</td>
                                <td class="text">admin</td>
                              </tr>
                              <tr>
                                <td>Customer</td>
                                <td class="colon">:</td>
                                <td class="text">MacQuoid</td>
                              </tr>
                            </tbody>
													</table>
												</div>
												<div class="col-sm-12 col-md-6 record mb-3">
													<table>
                            <tbody>
                              <tr>
                                <td>Total</td>
                                <td class="colon">:</td>
                                <td class="text">৳7050</td>
                              </tr>
                              <tr>
                                <td>Date</td>
                                <td class="colon">:</td>
                                <td class="text">17-09-2023 19:39:11</td>
                              </tr>
                            </tbody>
													</table>
												</div>
											</div>
											<p class="p-4 mb-4">Customer need to recheck the product once</p>
											<div class="btn-row d-flex align-items-center justify-content-between">
												<a href="javascript:void(0);" class="btn btn-info btn-icon flex-fill">Open</a>
												<a href="javascript:void(0);" class="btn btn-danger btn-icon flex-fill">Products</a>
												<a href="javascript:void(0);" class="btn btn-success btn-icon flex-fill">Print</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Recent Transactions -->

		<div class="customizer-links" id="setdata">
			<ul class="sticky-sidebar">
				<li class="sidebar-icons">
					<a href="#" class="navigation-add" data-bs-toggle="tooltip" data-bs-placement="left"
						data-bs-original-title="Theme">
						<i data-feather="settings" class="feather-five"></i>
					</a>
				</li>
			</ul>
		</div>
    <!-- Due Confirmation Modal -->
    <div v-if="showDueModal" class="confirm-backdrop" click.self="cancelDueSale">
      <div class="confirm-modal">

        <div class="confirm-header">
          <h4>Due Sale Confirmation</h4>
        </div>

        <div class="confirm-body">
          <div class="confirm-row">
            <span>Total Amount</span>
            <strong>৳ {{ calculateTotal() }}</strong>
          </div>

          <div class="confirm-row">
            <span>Paid Amount</span>
            <strong>৳ {{ receivedAmount || 0 }}</strong>
          </div>

          <div class="confirm-row due">
            <span>Due Amount</span>
            <strong>৳ {{ dueAmount }}</strong>
          </div>
        </div>

        <div class="confirm-actions">
          <button type="button" class="btn btn-secondary" @click="cancelDueSale">
            Cancel
          </button>
          <button type="button" class="btn btn-primary" @click="confirmDueSale">
            Confirm Sale
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import apiUrls from '@/urls'
import feather from "../../../../public/assets/js/feather.min";
import { useToast } from 'vue-toastification';

export default {
  data() {
    return {
      customer: {
        customer_name: '', customer_code: null, due_limit: null, due_limit_days: null, customer_address: '',
        customer_bank: '', customer_contact_person: '', customer_email: '', customer_phone: '', status: 'enabled',
      },

      query: '',
      results: [],
      c_query: '',
      c_results: [],
      selectedItem: 0,
      defaultCustomer: {
        id: 1,
        customer_name: 'Guest Customer',
      },
      selectedCustomer: null,
      selectedCustomerIndex: 0,
      debouncedSearch: null,
      addedItems: [],
      receivedAmount: null,
      error: null,
      voucher_id: null,
      discountPercent: 0,
      discountFixed: null,
      next_invoice_id: null,
      reference_no: null,
      payment_type: [],
      payment_method: null,
      total_due: null,
      global_vat_percentage: null,
      vat_policy: null,
      errors: {},
      errorMessage: "",
      bestSellingProducts: [],
      showDueModal: false,
      dueModalResolver: null,
    }
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  async mounted() {
    await this.posInvoiceNo();

    await this.fetchPaymentType();

    await this.fetchVatPercentage();

    await this.fetchBestSellingProducts();
  },

  computed: {
    total() {
      return this.calculateTotal();
    },

    received() {
      return Number(this.receivedAmount || 0);
    },

    netBalance() {
      return this.received - this.total;
    },

    isPayable() {
      return this.received < this.total;
    },

    isReturn() {
      return this.received > this.total;
    },

    dueAmount() {
      const total = Number(this.total) || 0;
      const received = Number(this.received) || 0;

      const due = total - received;

      return this.isPayable ? due.toFixed(2) : 0;
    },

    returnAmount() {
      return this.isReturn ? this.received - this.total : 0;
    },

    paymentDifference() {
      return Math.abs(this.calculateTotal() - Number(this.receivedAmount || 0));
    },

    formattedpaymenttypes() {
      if (!Array.isArray(this.payment_type)) return [];
      return this.payment_type.map(pt => ({
        id: pt.id,
        text: pt.text || pt.name
      }));
    },

    // vat calculation with inclusive discount calculation.
    vatAmount() {
      let subtotal = parseFloat(this.calculateSubtotal()) || 0;
      const discount = parseFloat(this.calculateDiscount()) || 0;
      const fixed_discount = parseFloat(this.calculateFixedDiscount()) || 0;
      const globalRate = Number(this.global_vat_percentage) || 0;

      const discountAmount = discount > 0 ? discount : fixed_discount;

      if (this.vat_policy === "No VAT") return 0;

      // Global VAT
      if (
          this.vat_policy === "Price including Global VAT" ||
          this.vat_policy === "Price excluding Global VAT"
      ) {
        if (!globalRate) return 0;
        let total_vat = 0;

        for (const item of this.addedItems) {
          const price = Number(item.selling_price) || 0;
          const qty = Number(item.quantity) || 0;

          if (price <= 0 || qty <= 0) continue;
          let item_base = price;

          if (this.vat_policy === "Price including Global VAT") {
            // remove vat
            const itemBaseAmount = item_base / (1 + globalRate / 100);

            // Apply discount on base
            const discountRaw = (itemBaseAmount * this.discountPercent) / 100;
            const perUnitDiscount = parseFloat(discountRaw.toFixed(2));
            const discountedBase = itemBaseAmount - perUnitDiscount;

            if (discountedBase <= 0) return 0;

            // Recalculate vat
            const vat_base = (discountedBase * globalRate) / 100;
            const perUnitVat = parseFloat(vat_base.toFixed(2));
            const vat = perUnitVat * qty

            total_vat += vat;

          } else {
            const discountRaw = (item_base * this.discountPercent) / 100;
            const perUnitDiscount = parseFloat(discountRaw.toFixed(2));
            const discountedSubtotal = item_base - perUnitDiscount;

            if (discountedSubtotal <= 0) return 0;
            const vat_base = (discountedSubtotal * globalRate) / 100;
            const perUnitVat = parseFloat(vat_base.toFixed(2));
            const vat = perUnitVat * qty

            total_vat += vat;
          }
        }
        return total_vat.toFixed(2);
      }

      // Item-wise VAT
      if (
          this.vat_policy === "Price including Item-wise VAT" ||
          this.vat_policy === "Price excluding Item-wise VAT"
      ) {

        let totalVat = 0;
        for (const item of this.addedItems) {
          const price = Number(item.selling_price) || 0;
          const qty = Number(item.quantity) || 0;
          const rate = Number(item.vat_value) || 0;
          const itemDiscountPercent = Number(item.discount) || 0;

          let baseAmount = price;

          // Remove VAT if inclusive
          if (this.vat_policy === "Price including Item-wise VAT" && rate > 0) {
            baseAmount = baseAmount / (1 + rate / 100);

            // Apply item discount
            const itemDiscount = (baseAmount * itemDiscountPercent) / 100;
            const discountedBase = baseAmount - itemDiscount;

            if (discountedBase <= 0) continue;

            // Recalculate VAT
            const vat_base = (discountedBase * rate) / 100;
            const perUnitVat = parseFloat(vat_base.toFixed(2));
            const vat = perUnitVat * qty;
            totalVat += vat;
          } else {
            // Apply item discount
            const itemDiscount = (baseAmount * itemDiscountPercent) / 100;
            const afterDiscount = baseAmount - itemDiscount;

            const vat_base = (afterDiscount * rate) / 100;
            const perUnitVat = parseFloat(vat_base.toFixed(2));
            const vat = perUnitVat * qty;
            totalVat += vat;
          }
        }
        return totalVat.toFixed(2);
      }
      return 0;
    },

    totalWithVat() {
      const subtotal = parseFloat(this.calculateSubtotal()) || 0;
      return (subtotal + Number(this.vatAmount)).toFixed(2);
    }
  },

  watch: {
    discountPercent(val) {
      if (val > 0) {
        this.discountFixed = null;
      }
    },

    discountFixed(val) {
      if (val > 0) {
        this.discountPercent = 0;
      }
    },

    global_vat_percentage(newVal) {
      if (isNaN(newVal) || newVal < 0) {
        this.global_vat_percentage = 0;
      } else if (newVal > 100) {
        this.global_vat_percentage = 100;
      }
    },

    vat_policy(newVal) {
      if (
          newVal === "Price including Item-wise VAT" ||
          newVal === "Price excluding Item-wise VAT"
      ) {
        // fetch VAT for ALL existing items
        this.addedItems.forEach(item => {
          this.fetchItemVat(item);
        });
      }
    },
  },

  methods: {
    async searchCustomer() {
        if (!this.c_query) {
          this.c_results = []
          return
        }

        try {
          const response = await this.$axios.get(apiUrls.customer_search.get, {
            params: { q: this.c_query }
          })
          this.c_results = response.data.results;
          this.selectedCustomer = 0;

        } catch (error) {
          console.error('Search error:', error)
          this.c_results = []
        }
      },

    async submitCustomer() {
      // Frontend validation before making API call
      this.errors = {};
      if (!this.customer.customer_name.trim()) this.errors.customer_name = this.$t('error.required');
      if (!this.customer.customer_phone.trim()) this.errors.customer_phone = this.$t('error.required');

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      try {
        const response = await this.$axios.post(apiUrls.customers.post, this.customer );
        this.toast.success(this.$t("customer_created"));

        // Close modal
        const modal = bootstrap.Modal.getInstance(document.getElementById("create"));
        modal.hide();

        // Redirect only after successful response
        this.$router.push('/pos');

        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
      }
    },

    handleKey(event) {
      if (event.key === 'ArrowDown') {
        this.selectedCustomerIndex = Math.min(this.selectedCustomerIndex + 1, this.c_results.length - 1);
      } else if (event.key === 'ArrowUp') {
        this.selectedCustomerIndex = Math.max(this.selectedCustomerIndex - 1, 0);
      } else if (event.key === 'Enter') {
        const customer = this.c_results[this.selectedCustomerIndex];
        if (customer) {
          this.selectCustomer(customer);
        }
      }
    },

    selectCustomer(customer) {
      this.selectedCustomer = { ...customer };
      this.c_query = customer.customer_name;
      this.c_results = [];
      this.selectedCustomerIndex = 0;

      this.fetchCustomerDue(customer.id);
    },

    async fetchCustomerDue(customer_id) {
      try{
        const response = await this.$axios.get(`${apiUrls.customer_due.get}${customer_id}`);
        this.total_due = response.data.total_due;

      }catch (error) {
        console.error("Error fetching customer due:", error);
      }
    },

    async fetchVatPercentage() {
      try {
        const response = await this.$axios.get(apiUrls.setting.get);
        const data = response.data;
        const setting = Array.isArray(data) ? data[0] : data;
        this.global_vat_percentage = parseFloat(setting.global_vat_percentage) || 0;
        this.vat_policy = setting.vat_policy;

      }catch (error) {
        console.error("Error fetching vat percentage:", error);
      }
    },

    cancelForm() {
      this.resetForm();

      // Close Bootstrap modal programmatically
      const modal = bootstrap.Modal.getInstance(document.getElementById("create"));
      if (modal) modal.hide();
    },

    resetForm() {
      this.customer = {
        customer_name: '', customer_code: null, due_limit: null, due_limit_days: null, customer_address: '',
        customer_bank: '', customer_contact_person: '', customer_email: '', customer_phone: '', status: 'enabled',
      };
      this.errors = {};
      this.errorMessage = "";
    },

    async fetchResults() {
      if (!this.query.trim()) {
        this.results = []
        return
      }

      try {
        const response = await this.$axios.get(apiUrls.item_search.get, {
          params: { q: this.query }
        })
        const results = response.data.results || [];
        this.results = results
        this.selectedItem = 0;

        if (
          results.length === 1 &&
          results[0].barcode_qr_code &&
          results[0].barcode_qr_code === this.query
        ) {
          await this.addItem(results[0])
          return
        }

        // render feather icons
        await this.$nextTick(() => {
          if (window.feather) feather.replace()
        })
      } catch (error) {
        console.error('Search error:', error)
        this.results = []
      }
    },

    handleKeys(event) {
      if (event.key === 'ArrowDown') {
        this.selectedItem = Math.min(this.selectedItem + 1, this.results.length - 1);
      } else if (event.key === 'ArrowUp') {
        this.selectedItem = Math.max(this.selectedItem - 1, 0);
      } else if (event.key === 'Enter') {
        const selectedProduct = this.results[this.selectedItem];
        if (selectedProduct && selectedProduct.id) {
          this.addItem(selectedProduct);
          this.query = '';
          this.results = [];
          this.selectedItem = 0;
        }
      }
    },

    async addItem(item) {
      if (!item.stock_quantity || item.stock_quantity <= 0) {
        this.toast.warning('Out of stock item cannot be added');
        return;
      }

      const existingItem = this.addedItems.find(i => i.id === item.id);

      if (existingItem) {
        existingItem.quantity = Math.min(existingItem.quantity + (item.quantity || 1), item.stock_quantity);
      } else {
        const newItem = {
          ...item,
          images: item.images || [],
          quantity: Math.min(item.quantity || 1, item.stock_quantity),
          vat_value: 0
        };

        // Fetch item-wise VAT value
        if (
          this.vat_policy === "Price including Item-wise VAT" ||
          this.vat_policy === "Price excluding Item-wise VAT"
        ) {
          await this.fetchItemVat(newItem);
        }

        this.addedItems = [...this.addedItems, newItem];

      }

      // Clear search UI
      this.query = '';
      this.results = [];
      this.selectedItem = 0;

      this.$nextTick(() => {
        if (window.feather) feather.replace();
      });
    },

    increaseQty(item) {
      if (item.quantity < item.stock_quantity) {
        item.quantity += 1;
      }
    },

    decreaseQty(item) {
      if (item.quantity > 1) {
        item.quantity -= 1;
      }
    },

    removeItem(item) {
      this.addedItems = this.addedItems.filter(i => i.id !== item.id);
      this.$nextTick(() => {
        if (window.feather) feather.replace();
      });
    },

    clearAll() {
      this.addedItems = [];
      this.discountPercent = 0;
      this.discountFixed = null;
      this.receivedAmount = null;
      this.$nextTick(() => {
        if (window.feather) feather.replace();
      })
    },

    clearSearch() {
      this.query = ''
      this.results = []
    },

    calculateSubtotal() {
      return this.addedItems.reduce((sum, item) =>
        sum + (item.selling_price || 0) * item.quantity, 0).toFixed(2);
    },

    calculateDiscount(raw=false) {
      let subtotal = parseFloat(this.calculateSubtotal()) || 0;

      if (subtotal <= 0) return "0.00";

      let discountAmount = 0;

      if (this.vat_policy === "No VAT") {
        if (this.discountPercent > 0) {
          discountAmount = (subtotal * this.discountPercent) / 100;
        }
        return discountAmount.toFixed(2);
      }

      if (
        this.vat_policy === "Price including Global VAT" ||
        this.vat_policy === "Price excluding Global VAT"
      ) {

        const rate = Number(this.global_vat_percentage) || 0;

        let total_discount = 0;
        for (const item of this.addedItems) {
          const price = Number(item.selling_price) || 0;
          const qty = Number(item.quantity) || 0;

          if (price <= 0 || qty <= 0) continue;
          let discountBase = price;

          if (this.vat_policy === "Price including Global VAT" && rate > 0) {
            discountBase = discountBase / (1 + rate / 100);
          }

          if (this.discountPercent > 0) {
            const discountAmountBase = (discountBase * this.discountPercent) / 100;
            const perUnitDiscount = parseFloat(discountAmountBase.toFixed(2));
            const item_discount = perUnitDiscount * qty;
            total_discount += item_discount;

          } else if (this.calculateFixedDiscount() > 0) {
            total_discount += parseFloat(this.calculateFixedDiscount());
          }

          if (raw) {
            return discountAmount
          }
        }
        return total_discount.toFixed(2);
      }

      if (
        this.vat_policy === "Price including Item-wise VAT" ||
        this.vat_policy === "Price excluding Item-wise VAT"
      ) {

        let totalDiscount = 0;
        for (const item of this.addedItems) {
          const price = Number(item.selling_price) || 0;
          const qty = Number(item.quantity) || 0;
          const vatRate = Number(item.vat_value) || 0;
          const discount_rate = Number(item.discount) || 0;

          // let item_total = price * qty;
          let discountBase = price;

          if ( this.vat_policy === "Price including Item-wise VAT" && vatRate > 0 ) {
            discountBase = discountBase / (1 + vatRate / 100);
          }
          if (discount_rate > 0) {
            const discountAmountBase = (discountBase * discount_rate) / 100;
            const perUnitDiscount = parseFloat(discountAmountBase.toFixed(2));
            discountAmount = perUnitDiscount * qty;
            totalDiscount += discountAmount;
          }
        }
        return totalDiscount.toFixed(2);
      }

      return "0.00";
    },

    calculateFixedDiscount() {
      const fixed = parseFloat(this.discountFixed) || 0;
      return fixed.toFixed(2);
    },

    calculateTotal() {
      let subtotal = Number(this.calculateSubtotal()) || 0;
      let discount = Number(this.calculateDiscount(true)) || 0;
      let vat = Number(this.vatAmount) || 0;

      // No vat
      if (this.vat_policy === "No VAT") {
        let total = subtotal - discount;
        return total.toFixed(2)
      }

      // GLOBAL VAT
      if (
        this.vat_policy === "Price including Global VAT" ||
        this.vat_policy === "Price excluding Global VAT"
      ) {
        const rate = Number(this.global_vat_percentage) || 0;
        let grandTotal = 0;

        for (const item of this.addedItems) {
          const price = Number(item.selling_price) || 0;
          const qty = Number(item.quantity) || 0;

          if (price <= 0 || qty <= 0) continue;
          let basePrice = price;

          if (this.vat_policy === "Price including Global VAT" && rate > 0) {
            // remove vat
            const itemBaseAmount = basePrice / (1 + rate / 100);

            // Apply discount on base
            const perUnitDiscount = (itemBaseAmount * this.discountPercent) / 100;
            const discountedBase = itemBaseAmount - perUnitDiscount;

            // Recalculate vat
            const perUnitVat = (discountedBase * rate) / 100;
            const perItemAmount = discountedBase + perUnitVat;
            const total_amount = perItemAmount * qty;
            grandTotal += total_amount;

          } else {
            const discountRaw = (basePrice * this.discountPercent) / 100;
            const total_discount = parseFloat(discountRaw.toFixed(2));
            const discountedSubtotal = basePrice - total_discount;

            if (discountedSubtotal <= 0) return 0;
            const vat_base = (discountedSubtotal * rate) / 100;
            const total_vat = parseFloat(vat_base.toFixed(2));
            const perItemAmount = discountedSubtotal + total_vat;
            const total_amount = perItemAmount * qty;
            grandTotal += total_amount;
          }
        }
        return grandTotal.toFixed(2);
      }

      // ITEM-WISE VAT
      if (
        this.vat_policy === "Price including Item-wise VAT" ||
        this.vat_policy === "Price excluding Item-wise VAT"
      ) {

        let grandTotal = 0;

        for (const item of this.addedItems) {
          const price = Number(item.selling_price) || 0;
          const qty = Number(item.quantity) || 0;
          const vatRate = Number(item.vat_value) || 0;
          const discountRate = Number(item.discount) || 0;

          let itemTotal = price * qty;

          // Remove VAT if price is VAT inclusive
          if (
            this.vat_policy === "Price including Item-wise VAT" &&
            vatRate > 0
          ) {
            itemTotal = itemTotal / (1 + vatRate / 100);

            if (discountRate > 0) {
              itemTotal -= (itemTotal * discountRate) / 100;
            }
            if (vatRate > 0) {
              itemTotal += (itemTotal * vatRate) / 100;
            }

          } else if (this.vat_policy === "Price excluding Item-wise VAT" &&
            vatRate > 0
          ) {
            itemTotal -= (itemTotal * discountRate) / 100;
            itemTotal += (itemTotal * vatRate) / 100;
          }

          grandTotal += itemTotal;
        }

        return grandTotal.toFixed(2);
      }

      return "0.00";
    },

    getPaymentIcon(method) {
      switch (method) {
        case 'Cash':
          return '/assets/img/icons/cash.svg';
        case 'Bank':
          return '/assets/img/icons/bank.png';
        case 'Mobile':
          return '/assets/img/icons/mobile.png';
        default:
          return '';
      }
    },

    async posInvoiceNo() {
      try {
        const response = await this.$axios.get(apiUrls.pos_new_invoice.get);
        this.next_invoice_id = response.data.new_voucher_id;
      } catch (error) {
        console.error("Failed to fetch invoice:", error);
      }
    },

    async fetchPaymentType() {
      try {
        const response = await this.$axios.get(apiUrls.payment_type.get);
        this.payment_type = response.data;

        if (this.payment_type.length > 0 && !this.payment_method) {
          this.payment_method = this.payment_type[0].id;
        }
      } catch (error) {
        console.error("Error fetching payment type:", error);
      }
    },

    openDueModal() {
      return new Promise((resolve) => {
        this.dueModalResolver = resolve;
        this.showDueModal = true;
      });
    },

    confirmDueSale() {
      this.showDueModal = false;
      if (this.dueModalResolver) this.dueModalResolver(true);
    },

    cancelDueSale() {
      this.showDueModal = false;
      if (this.dueModalResolver) this.dueModalResolver(false);
    },

    async submitPayment() {
      // prevent blank payment
      if (!Array.isArray(this.addedItems) || this.addedItems.length === 0) {
        this.toast.warning('No items added for payment');
        return;
      }

      const total = parseFloat(this.calculateTotal());
      const received = parseFloat(this.receivedAmount) || 0;
      const reference = this.reference_no;

      if (Number(this.payment_method) !== 1010101 && !reference?.trim()) {
        this.toast.warning('Reference No is required for this payment type');
        return;
      }

      const customer_id = this.selectedCustomer?.id || 1;
      if (customer_id === 1 && this.dueAmount) {
        this.toast.info("Guest customer cannot have due.");
        return;
      }

      // check customer due limit.
      const due_limit = Number(this.selectedCustomer?.due_limit || 0);
      const total_due = Number(this.total_due || 0);
      const present_due = total_due + Number(this.dueAmount || 0);

      if (due_limit > 0 && (total_due > due_limit || present_due > due_limit)) {
        this.toast.info("Due limit exceeds for this customer");
        return;
      }

      if (this.dueAmount > 0) {
        const confirmed = await this.openDueModal();
        if (!confirmed) {
          this.toast.info("Submission cancelled.");
          return;
        }
      }

      try {
        let discount = 0;
        if (this.discountPercent && this.discountPercent > 0) {
          discount = parseFloat(this.calculateDiscount()) || 0;
        } else if (this.discountFixed && this.discountFixed > 0) {
          discount = parseFloat(this.calculateFixedDiscount()) || 0;
        } else {
          discount = parseFloat(this.calculateDiscount()) || 0;
        }

        const customer_id = this.selectedCustomer?.id || 1;

        const payload = {
          sub_total: parseFloat(this.calculateSubtotal()),
          discount,
          tax: parseFloat(this.vatAmount) || 0,
          total,
          received_amount: received || 0,
          payment_method: this.payment_method,
          reference_no: reference || 0,
          due_amount: this.dueAmount || 0,
          return_amount: this.returnAmount || 0,
          customer_id,
          vat_amount: this.vatAmount || 0,
          vat_policy: this.vat_policy,
          global_vat_percentage: this.global_vat_percentage,
          discount_percent: this.discountPercent,

          items: this.addedItems.map(item => ({
            item_id: item.id,
            item_name: item.item_name,
            quantity: item.quantity,
            selling_price: item.selling_price,
            vatRate: item.vat_value || 0,
            discountRate: item.discount || 0,
          }))
        };

        const response = await this.$axios.post(apiUrls.pos_pay.post, payload);
        this.voucher_id = response.data.voucher_id

        if (response.data && response.data.voucher_id) {
          this.toast.success(`Payment successful. Voucher ID: ${response.data.voucher_id}`);
          await this.posInvoiceNo();
          await this.fetchBestSellingProducts();
          this.c_query = '';
          this.c_results = [];
          this.selectedCustomer = {...this.defaultCustomer};
          this.selectedCustomerIndex = 0;
          this.total_due = null;

        } else {
          this.toast.success('Payment successful!');
        }

        this.resetPosEntries();

      } catch (error) {
        let message = "An unknown error occurred";

        if (error?.response?.data) {
          const data = error.response.data;

          if (typeof data === "string") {
            message = data;
          } else if (data.detail) {
            message = data.detail;
          } else {
            // handle field errors (DRF serializer errors)
            message = Object.values(data).flat().join(", ");
          }
        } else if (error?.message) {
          message = error.message;
        }

        this.toast.error(`Payment failed: ${message}`);
      }
    },

    async fetchBestSellingProducts() {
      this.loading = true
      try {
        const res = await this.$axios.get(apiUrls.pos_best_selling.get)
        this.bestSellingProducts = res.data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async fetchItemVat(item) {

      if (!item?.vat_group) return;

      try {
        const { data } = await this.$axios.get(`${apiUrls.item_vat.get}${item.vat_group}/`);
        const vat = data?.results?.[0];
        item.vat_value = vat ? Number(vat.vat_value) : 0;

        // render feather icons
        await this.$nextTick(() => {
          if (window.feather) feather.replace()
        })
      } catch (error) {
        console.error('Search error:', error)
      }
    },

    isItemWiseVat() {
      return this.vat_policy === "Price including Item-wise VAT" ||
          this.vat_policy === "Price excluding Item-wise VAT";
    },

    resetPosEntries() {
      this.addedItems = [];
      this.discountPercent = 0;
      this.discountFixed = null;
      this.receivedAmount = null;
      this.reference_no = '';
      this.payment_method = Array.isArray(this.payment_type) && this.payment_type.length > 0
        ? this.payment_type[0].id
        : null;

      this.selectedCustomer = { ...this.defaultCustomer };
      this.selectedCustomerIndex = 0;
      this.total_due = null;
      this.c_query = '';
      this.c_results = [];
      this.$nextTick(() => {
        if (window.feather) feather.replace();
      })
    },

  },

  created() {
    this.debouncedSearch = debounce(this.fetchResults, 300)

    // initialize customer
    this.selectedCustomer = { ...this.defaultCustomer };
  },
};
</script>

<style>
/* Style the dropdown toggle button */
.nav-link.select-store {
  padding: 8px 20px;
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Dropdown menu styling */
.dropdown-menu {
  min-width: 200px;
  padding: 10px 0;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-item img {
  width: 20px;
  margin-right: 10px;
}

.big-placeholder::placeholder {
  font-size: 1.25rem;
}
</style>

